import { createFileRoute } from "@tanstack/react-router";

import { Navigate } from "@/lib/router-compat";
export const Route = createFileRoute("/sacramento-dinners")({
  component: () => <Navigate to="/cities/sacramento" replace />,
});
